module.exports = __webpack_public_path__ + "static/img/title.8212d3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/raz_weinfelden/title.jpg
// module id = 450
// module chunks = 1